export default __webpack_public_path__ + "static/media/goldBar.f6cde62c.png";